<template>
  <div class="pl-page">
    <pro-list-frame
      v-if="isDesktopListLayout"
      ref="plTable"
      :title="(type == 'review' ? $t('reviewAccount') : $t(type))"
      icon="mdi-scale-balance"
      :total="totalItems"
      :rows="items.length"
      :search.sync="search"
      :columns="toggleableHeaders"
      :hidden="hiddenColumns"
      :selected-count="(selected || []).length"
      :loading="loading"
      :cell-sel="cellSel"
      :fixed="!mobileShow"
      @refresh="getItems"
      @print="printStudio = true"
      @filter="filter = true"
      @toggle-column="toggleColumn"
      @show-all-columns="hiddenColumns = []"
      @cell-down="onCellDown"
      @cell-over="onCellOver"
      @clear-cells="clearCellSel"
      @clear-selection="selected = []"
    >
      <template #tools>
      <export-excel
        ref="refExcel"
        :data="excelItems"
        worksheet="abriron.com"
        name="data-ai.xls"
        type="xls"
        :title="$store.state.abrName"
        :total-prop="pageCount"
        :page-prop="excelPage"
        @getAllRows="getAllRows"
      >
        <button type="button" class="pl-btn pl-btn--icon" :title="$t('excel')">
          <v-icon size="16" color="#2E7D32">mdi-file-excel-outline</v-icon>
        </button>
      </export-excel>
      <v-menu offset-y left>
        <template v-slot:activator="{ attrs, on }">
          <button type="button" class="pl-btn pl-btn--icon" v-bind="attrs" v-on="on">
            <v-icon size="16">mdi-dots-vertical</v-icon>
          </button>
        </template>
        <v-list dense>
          <log
            v-if="
              $store.state.permissions && $store.state.permissions.includes('logList')
            "
            ref="logRef"
            :type-prop="type"
            :listProp="true"
            mode-prop="button"
          />
          
          
          
        </v-list>
      </v-menu>
      </template>
      <template #bulk>
      <button
        type="button"
        class="pl-bulk__btn pl-bulk__btn--danger"
        @click="deletDialog = true"
      >
        <v-icon size="17">mdi-trash-can-outline</v-icon>
        {{ $t("remove") }}
      </button>
      </template>
      <template #top>
<v-row class="mt-1 mx-2">
      <!-- <v-col class="d-flex py-0"> -->
      <v-col cols="12" md="2" class="px-0">
        <v-select
          v-model="remain"
          :label="$t('remainType')"
          :items="remainItems"
          height="32"
          dense
          outlined
          hide-details
          item-value="value"
          item-text="text"
          @input="handleInput"
        />
      </v-col>
      <v-col cols="12" md="2" class="pe-0">
        <autocomplete
          v-model="fromFinancialYear"
          :title="$t('fromFinancialYear')"
          type="year"
          :value="fromFinancialYear"
          @input="handleInput"
        />
      </v-col>
      <v-col cols="12" md="2" class="pe-0">
        <autocomplete
          v-model="toFinancialYear"
          :title="$t('toFinancialYear')"
          type="year"
          :value="toFinancialYear"
          @input="handleInput"
        />
      </v-col>
      <v-col cols="12" md="2" class="pe-0">
        <v-select
          v-model="filterType"
          :label="$t('filter')"
          :items="filterTypeItems"
          height="32"
          dense
          outlined
          hide-details
          item-value="value"
          item-text="text"
        />
      </v-col>
      <v-col v-show="filterType == 'month'" cols="12" md="2" class="pe-0">
        <template>
          <v-text-field
            id="fromIdMonth"
            v-model="fromMonth"
            :label="$t('from') + ' ' + $t('month')"
            outlined
            dense
            clearable
          />
          <date-picker
            v-model="fromMonth"
            element="fromIdMonth"
            locale="fa,en"
            auto-submit
            type="year-month"
            format="jYYYY/jMM"
            :min="fromFinancialYear ? fromFinancialYear.start_date : null"
            :max="toFinancialYear ? toFinancialYear.end_date : null"
            simple
            :color="
              $vuetify.theme.themes[$vuetify.theme.isDark ? 'dark' : 'light']
                .primary
            "
            @change="getItems"
          />
        </template>
      </v-col>
      <v-col v-show="filterType == 'month'" cols="12" md="2" class="pe-0">
        <template>
          <v-text-field
            id="toIdMonth"
            v-model="toMonth"
            :label="$t('until') + ' ' + $t('month')"
            outlined
            dense
            clearable
          />
          <date-picker
            v-model="toMonth"
            element="toIdMonth"
            locale="fa,en"
            auto-submit
            type="year-month"
            format="jYYYY/jMM"
            :min="fromFinancialYear ? fromFinancialYear.start_date : null"
            :max="toFinancialYear ? toFinancialYear.end_date : null"
            simple
            :color="
              $vuetify.theme.themes[$vuetify.theme.isDark ? 'dark' : 'light']
                .primary
            "
            @change="getItems"
          />
        </template>
      </v-col>
      <v-col v-show="filterType == 'date'" cols="12" md="2" class="pe-0">
        <template>
          <v-text-field
            id="fromId"
            v-model="fromDate"
            :label="$t('from') + ' ' + $t('date')"
            outlined
            dense
            clearable
          />
          <date-picker
            v-model="fromDate"
            element="fromId"
            :locale="$store.state.date_locale"
            :format="$store.state.date_format"
            auto-submit
            :color="
              $vuetify.theme.themes[$vuetify.theme.isDark ? 'dark' : 'light']
                .primary
            "
            @close="setDate"
            @change="getItems"
          />
        </template>
      </v-col>
      <v-col v-show="filterType == 'date'" cols="12" md="2" class="pe-0">
        <template>
          <v-text-field
            id="toId"
            v-model="toDate"
            :label="$t('until') + ' ' + $t('date')"
            outlined
            dense
            clearable
          />
          <date-picker
            v-model="toDate"
            element="toId"
            :locale="$store.state.date_locale"
            :format="$store.state.date_format"
            :min="fromDate"
            auto-submit
            :color="
              $vuetify.theme.themes[$vuetify.theme.isDark ? 'dark' : 'light']
                .primary
            "
            @close="setDate"
            @change="getItems"
          />
        </template>
      </v-col>
      <!-- </v-col> -->
    </v-row>
    <v-row class="mx-2">
      <v-col cols="12" md="2" class="px-0">
        <autocomplete
          v-model="branch"
          title="branch"
          type="branch"
          :filter="true"
          :multiple="true"
          @input="getItems"
        />
      </v-col>
      <v-col cols="12" md="6" class="pe-0">
        <tag v-model="tag" :solo="false" :input="tag" :height="25" @input="getItems" />
      </v-col>
      <v-col cols="12" md="2" class="pe-0">
        <v-text-field
          v-model="fromNum"
          height="20"
          dense
          outlined
          class="dense"
          clearable
          :label="$t('from-number')"
          ref="number"
          @input="getItems"
        />
      </v-col>
      <v-col cols="12" md="2" class="pe-0">
        <v-text-field
          v-model="toNum"
          height="20"
          dense
          outlined
          class="dense"
          clearable
          :label="$t('toNumber')"
          ref="number"
          @input="getItems"
        />
      </v-col>
    </v-row>
    <v-row class="mx-2">
      <v-col cols="12" md="2" class="px-0">
        <autocomplete
          v-model="group"
          title="group"
          type="group"
          :multiple="true"
          :solo="false"
          :dense="false"
          @input="getItems"
        />
      </v-col>
      <v-col cols="12" md="2" class="pe-0">
        <autocomplete
          v-model="total"
          title="total"
          type="total"
          :multiple="true"
          :solo="false"
          :dense="false"
          @input="getItems"
        />
      </v-col>
      <v-col cols="12" md="2" class="pe-0">
        <autocomplete
          v-model="given"
          title="given"
          type="given"
          :multiple="true"
          :solo="false"
          :dense="false"
          @input="getItems"
        />
      </v-col>
      <v-col cols="12" md="2" class="pe-0">
        <autocomplete
          v-model="fin4"
          title="detail"
          type="detail"
          :multiple="true"
          @input="getItems"
        />
      </v-col>
      <v-col cols="12" md="2" class="pe-0">
        <autocomplete
          v-model="fin5"
          title="fin5"
          type="detail"
          :multiple="true"
          @input="getItems"
        />
      </v-col>
      <v-col cols="12" md="2" class="pe-0">
        <autocomplete
          v-model="fin6"
          title="fin6"
          type="detail"
          :multiple="true"
          @input="getItems"
        />
      </v-col>
      <v-col cols="12" md="2" class="px-0">
        <autocomplete
          v-model="documentType"
          :title="$t('documentType')"
          type="documentType"
          :filter="true"
          :multiple="true"
          @input="getItems"
        />
      </v-col>
      <v-col cols="12" md="2" class="pt-0">
        <v-checkbox
          color="primary"
          v-model="closing_doc_status"
          :label="$t('report without closing document')"
        >
        </v-checkbox>
      </v-col>
      <v-col cols="12" md="2" class="pt-0">
        <v-checkbox
          color="primary"
          v-model="opening_doc_status"
          :label="$t('report without opening document')"
        >
        </v-checkbox>
      </v-col>
      <v-col cols="12" md="2" class="pt-0">
        <v-checkbox
          color="primary"
          v-model="temperory_doc_status"
          :label="$t('report without temporary document')"
        >
        </v-checkbox>
      </v-col>
      <v-col cols="12" md="2" class="pe-2">
        <v-btn block small color="primary" height="32" @click="getItems">
          {{ $t("updateReport") }}
        </v-btn>
      </v-col>
    </v-row>
    <v-row class="mx-2 mb-2 mt-0">
      <v-col cols="12" class="pa-0">
        <v-chip-group v-model="level" active-class="primary--text" column mandatory>
          <v-chip
            v-for="levelitem in levelItems"
            :key="levelitem"
            label
            class="ms-0 me-1"
            small
            :value="levelitem"
          >
            {{ $t(levelitem) }}
          </v-chip>
          <v-chip
            v-shortkey="['f6']"
            label
            value="back"
            class="ms-0 me-1"
            small
            @shortkey="backLevel(level)"
          >
            {{ $t("backToUpLevel") }} (f6)
          </v-chip>
        </v-chip-group>
      </v-col>
    </v-row>
      </template>
      <v-data-table
        v-if="headers"
        v-model="selected"
        :height="mobileShow ? 323 : plTableH"
        fixed-header
        :headers="tableHeaders"
        :items="items"
        :options.sync="options"
        :server-items-length="totalItems"
        :loading="false"
        :page.sync="page"
        multi-sort
        dense
        :show-select="showSelect"
        item-key="id"
        :footer-props="plFooterProps"
      >
        <template v-slot:item.actions="{ item }">
          <div class="pl-action-cell">
          <v-menu offset-y>
            <template v-slot:activator="{ attrs, on }">
              <v-btn
                color="primary"
                class="pl-action-cell__btn"
                v-bind="attrs"
                icon
                x-small
                v-on="on"
              >
                <v-icon small>mdi-dots-vertical</v-icon>
              </v-btn>
            </template>

            <v-list dense>
              <v-list-item link @click="edit(item)">
                <v-list-item-icon>
                  <v-icon>mdi-clipboard-edit</v-icon>
                </v-list-item-icon>
                <v-list-item-title v-text="$t('edit')" />
              </v-list-item>
              <v-list-item
                v-clipboard:copy="
                  $baseURL +
                  '/' +
                  (typeForm == 'product' ? 'product' : 'service') +
                  '/edit/' +
                  item.id
                "
                link
              >
                <v-list-item-icon>
                  <v-icon>mdi-link</v-icon>
                </v-list-item-icon>
                <v-list-item-title v-text="$t('copy-link')" />
              </v-list-item>
              <!-- <v-list-item link @click="openDeleteDialog(item)">
                <v-list-item-icon>
                  <v-icon color="pink"> mdi-trash-can-outline </v-icon>
                </v-list-item-icon>
                <v-list-item-title v-text="$t('remove')" />
              </v-list-item> -->
            </v-list>
          </v-menu>
          <span class="pl-action-cell__row">{{
            parseInt(items.indexOf(item)) + parseInt(from)
          }}</span>
          </div>
        </template>
        <template v-slot:item.user="{ item }">
          {{ item.user.firstname }} ( {{ item.user.lastname }} )
        </template>
        <template v-slot:item.code="{ item }">
          {{ item.fullCode ? item.fullCode : $t("haveNot") }}
        </template>
        <template v-slot:item.reviewContent="{ item }">
          <v-tooltip bottom content-class="small-tooltip">
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                size="18"
                v-bind="attrs"
                v-on="{ ...on, click: () => visitTurnOver(item) }"
                style="cursor: pointer"
              >
                mdi-file-document
              </v-icon>
            </template>
            <span>{{ $t("go-to-turnover") }}</span>
          </v-tooltip>
          <v-btn text small @click="setLevel(item)">
            {{ item.fullName }}
          </v-btn>
        </template>
        <template v-slot:item.sumDebtor="{ item }">
          <span v-if="item.sumDebtor > 0 || item.sumDebtor == 0">
            {{ $numberFormat(item.sumDebtor) }}
          </span>
          <span v-if="item.sumDebtor < 0" style="color: red">
            ({{ Math.abs($numberFormat(item.sumDebtor)) }})
          </span>
        </template>
        <template v-slot:item.sumCreditor="{ item }">
          <span v-if="item.sumCreditor > 0 || item.sumCreditor == 0">
            {{ $numberFormat(item.sumCreditor) }}
          </span>
          <span v-if="item.sumCreditor < 0" style="color: red">
            ({{ Math.abs($numberFormat(item.sumCreditor)) }})
          </span>
        </template>
        <template v-slot:item.debtorRemain="{ item }">
          {{
            $numberFormat(
              item.sumDebtor - item.sumCreditor > 0
                ? item.sumDebtor - item.sumCreditor
                : 0
            )
          }}
        </template>
        <template v-slot:item.creditorRemain="{ item }">
          {{
            $numberFormat(
              item.sumCreditor - item.sumDebtor > 0
                ? item.sumCreditor - item.sumDebtor
                : 0
            )
          }}
        </template>
        <template v-slot:body.append>
          <tr :class="{ 'v-data-table__mobile-table-row': isMobile }">
            <td
              :colspan="`${isMobile ? 6 : 4}`"
              :class="{ 'v-data-table__mobile-row': isMobile }"
            >
              <strong>{{ $t("sum") }}</strong>
            </td>
            <td
              :colspan="`${isMobile ? 6 : 1}`"
              :class="{ 'v-data-table__mobile-row': isMobile }"
            >
              {{ isMobile ? $t("debtor") + ":" : "" }} {{ $numberFormat(totals.debtor) }}
            </td>
            <td
              :colspan="`${isMobile ? 6 : 1}`"
              :class="{ 'v-data-table__mobile-row': isMobile }"
            >
              {{ isMobile ? $t("creditor") + ":" : "" }}
              {{ $numberFormat(totals.creditor) }}
            </td>
            <td
              :colspan="`${isMobile ? 6 : 1}`"
              :class="{ 'v-data-table__mobile-row': isMobile }"
            >
              {{ isMobile ? $t("debtorRemain") + ":" : "" }}
              {{ $numberFormat(totals.debtorRemain) }}
            </td>
            <td
              :colspan="`${isMobile ? 6 : 1}`"
              :class="{ 'v-data-table__mobile-row': isMobile }"
            >
              {{ isMobile ? $t("creditorRemain") + ":" : "" }}
              {{ $numberFormat(totals.creditorRemain) }}
            </td>
          </tr>
          <tr
            v-if="$route.name === 'profit&cost'"
            :class="{ 'v-data-table__mobile-table-row': isMobile }"
          >
            <td
              :colspan="`${isMobile ? 6 : 6}`"
              :class="{ 'v-data-table__mobile-row': isMobile }"
            >
              <strong>{{ $t("remain") }}</strong>
            </td>
            <td
              :colspan="`${isMobile ? 6 : 2}`"
              :class="{ 'v-data-table__mobile-row': isMobile }"
              class="text-center"
              style="font-size: 18px; font-weight: bold"
            >
              {{ isMobile ? $t("remain") + ":" : "" }}
              {{ $numberFormat(+totals.creditorRemain - +totals.debtorRemain) }}
            </td>
          </tr>
        </template>
        <template v-slot:footer.page-text="{ pageStart, pageStop, itemsLength }">
          {{ faNum(pageStart) }}–{{ faNum(pageStop) }} {{ $t("of") }} {{ faNum($numberFormat(itemsLength)) }}
        </template>
        <template v-slot:footer.prepend>
          <v-col v-show="!isMobile" cols="1" class="pa-0" style="margin-top: -10px">
            <v-text-field
              v-model.number="page"
              :label="$t('goToPage')"
              min="1"
              :max="pageCount"
              type="number"
              outlined
              height="32"
              hide-details
              hide-spin-buttons
              dense
              :suffix="'  /  ' + pageCount"
            />
          </v-col>
        </template>
      </v-data-table>
    </pro-list-frame>
    <pro-list-mobile
      v-else
      :title="(type == 'review' ? $t('reviewAccount') : $t(type))"
      :items="items"
      :total="totalItems"
      :loading="loading"
      :page="plPage"
      :page-count="pageCount || 1"
      :search.sync="search"
      :filterable="true"
      :printable="true"
      :card="plAutoCard"
      :actions="plAutoActions"
      @load-more="plLoadPage"
      @refresh="plLoadPage(1)"
      @print="printStudio = true"
      @filter="filter = true"
    />
    <print-studio
      v-model="printStudio"
      :report="plReportKey"
      :title="(type == 'review' ? $t('reviewAccount') : $t(type))"
      :columns="plPrintCols"
      :source="plPrintSource"
      @error="serverErrorHandeler"
    />

    <v-dialog
      v-model="printDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      width="70%"
    >
      <v-card>
        <v-col class="d-flex pb-0">
          <v-btn icon color="grey darken-2" @click="printDialog = false">
            <v-icon class="close-hover" large> mdi-close </v-icon>
          </v-btn>
          <p class="mx-auto font-weight-medium mt-2">
            {{ $t("print") }}
          </p>
        </v-col>
        <v-row class="ma-0">
          <print
            :header-prop="showHeaders"
            :items-prop="items"
            :review-level-prop="level"
            :review-totals-prop="totals"
            :title="$t($route.name)"
          />
        </v-row>
        <v-card-actions />
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="filter"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      max-width="720"
      scrollable
      content-class="acf-wrap"
    >
      <div class="acf acf--compact" :style="proListRootStyle" dir="rtl">
        <header class="acf-head">
          <span class="acf-head__icon">
            <v-icon size="18">mdi-filter-variant</v-icon>
          </span>
          <div class="acf-head__titles">
            <div class="acf-head__title">{{ reviewFilterTitle }}</div>
            <div class="acf-head__sub">
              <template v-if="activeFilterChips.length">
                <span class="acf-badge">{{ faNum(activeFilterChips.length) }}</span>
                {{ $t("accFilterActive") }}
              </template>
              <template v-else>{{ $t("accFilterNone") }}</template>
            </div>
          </div>
          <button type="button" class="acf-x" :title="$t('close')" @click="filter = false">
            <v-icon size="18">mdi-close</v-icon>
          </button>
        </header>

        <div class="acf-body">
          <section class="acf-sec">
            <div class="acf-sec__head">
              <v-icon size="17">mdi-tune-variant</v-icon>
              {{ $t("accountFilterStatus") }}
            </div>
            <div class="acf-grid acf-grid--3">
              <status v-model="sellStatus" :hideconfig="true" />
              <tag v-model="tag" />
              <v-select
                v-model="selectedHeaders"
                :items="headers"
                :label="$t('sellFilterColumns')"
                dense
                outlined
                multiple
                return-object
                hide-details
              >
                <template v-slot:selection="{ item, index }">
                  <span v-if="index === 0" class="acf-sel">{{ item.text }}</span>
                  <span v-if="index === 1" class="acf-sel acf-sel--more">
                    +{{ faNum(selectedHeaders.length - 1) }}
                  </span>
                </template>
              </v-select>
            </div>
          </section>
        </div>

        <footer class="acf-foot">
          <button type="button" class="acf-btn acf-btn--primary" @click="getItems">
            <v-icon size="16">mdi-filter-check-outline</v-icon>
            {{ $t("accFilterApply") }}
          </button>
          <button
            type="button"
            class="acf-btn acf-btn--ghost"
            :disabled="!activeFilterChips.length"
            @click="resetFilters"
          >
            <v-icon size="16">mdi-filter-remove-outline</v-icon>
            {{ $t("accDocListClearFilters") }}
          </button>
          <span class="acf-spacer" />
          <button type="button" class="acf-btn" @click="filter = false">
            {{ $t("cancel") }}
          </button>
        </footer>
      </div>
    </v-dialog>
    <v-dialog
      v-model="taskDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      width="90%"
    >
      <v-card>
        <v-col class="d-flex">
          <v-btn icon color="grey darken-2" @click="taskDialog = false">
            <v-icon class="close-hover" large> mdi-close </v-icon>
          </v-btn>
          <p class="mx-auto font-weight-medium mt-2">
            {{ $t("task") }}
          </p>
        </v-col>
        <v-row class="ma-0">
          <task
            task-type="account"
            :ref-id="refId"
            :task-id="taskId"
            @close="taskDialog = false"
          />
        </v-row>
        <v-card-actions />
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="deletDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      width="400"
    >
      <v-card>
        <v-col>
          <v-btn icon class="close-hover" @click="deletDialog = false">
            <v-icon color="grey" large> mdi-close </v-icon>
          </v-btn>
        </v-col>
        <v-col>
          <v-img class="mx-auto" width="200" src="@/assets/stop.svg" />
        </v-col>
        <v-col class="mt-3 pr-7">
          <p class="mx-auto font-weight-medium">
            {{ $t("are-you-sure-delete-this-case") }}
          </p>
        </v-col>
        <v-card-actions>
          <v-row class="ma-0">
            <v-col cols="6">
              <v-btn v-if="selected.length > 0" color="primary" @click="removegroup">
                {{ $t("remove") }}
              </v-btn>
              <v-btn v-if="selected.length == 0" color="primary" @click="remove">
                {{ $t("remove") }}
              </v-btn>
            </v-col>
            <v-col cols="6">
              <v-btn
                color="grey"
                outlined
                class="float-left"
                @click="deletDialog = false"
              >
                {{ $t("cancel") }}
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <snakbar
      v-model="snakbar"
      :text="snakbarText"
      :active="snakbar"
      :color="snakbarColor"
    />
  </div>
</template>

<script>
import Task from "../task/task";
import Print from "../../components/general/Print/Index";
import General from "../../../../Mixins/general";
import autocomplete from "../../components/general/patial/autocomplete";
import ProList from "@/Mixins/proList";
import ProListFrame from "@/components/proList/ProListFrame.vue";
import ProListMobile from "@/components/proList/ProListMobile.vue";
import PrintStudio from "@/modules/print/PrintStudio.vue";
export default {
  name: "Review",
  components: {
    ProListFrame,
    ProListMobile,
    PrintStudio,
    Snakbar: () => import("../../components/general/snakbar/snakbar"),
    Tag: () => import("../../components/general/Tag/tag"),
    Status: () => import("../../components/general/Status/status"),
    Print,
    autocomplete,
    Task,
  },
  mixins: [General, ProList],
  props: ["input", "refId", "accountProp", "mobileShow"],
  data: () => ({
    selected: [],
    pageCount: 1,
    page: 1,
    filterType: "month",
    filterTypeItems: null,
    excelItems: null,
    getTurnover: false,
    fromFinancialYear: null,
    toFinancialYear: null,
    fromNum: null,
    toNum: null,
    documentType: null,
    remain: "debtorCreditor",
    remainItems: [],
    fromMonth: null,
    fromMonthItems: null,
    toMonthItems: null,
    toMonth: null,
    fromDate: null,
    toDate: null,
    printDialog: false,
    deletDialog: false,
    filter: false,
    level: "group",
    productStatus: null,
    productStatusItems: null,
    model: null,
    from: 1,
    taskDialog: null,
    tag: null,
    levelItems: ["group", "total", "given", "detail", "fin5", "fin6"],
    temp: null,
    deleteItem: null,
    sellStatus: null,
    items: [],
    sortBy: [],
    dialog: null,
    timer: 0,
    totalItems: 0,
    snakbar: false,
    total: null,
    group: null,
    typeForm: null,
    taskId: null,
    snakbarText: null,
    loading: true,
    options: {
      itemsPerPage: 5,
    },
    headers: null,
    type: null,
    search: null,
    selectedHeaders: [],
    headersMap: null,
    fin4: null,
    fin5: null,
    fin6: null,
    given: null,
    documentTypeItems: null,
    closing_doc_status: false,
    opening_doc_status: false,
    temperory_doc_status: false,
    isReady: false,
  }),
  computed: {
    reviewFilterTitle() {
      return this.$route.name === "profit&cost"
        ? this.$t("profitCostFilterTitle")
        : this.$t("reviewFilterTitle");
    },
    activeFilterChips() {
      var app = this;
      var has = function (v) {
        if (Array.isArray(v)) return v.length > 0;
        return v !== null && v !== undefined && v !== "" && v !== "0" && v !== 0;
      };
      var show = function (v) {
        if (Array.isArray(v)) return v.length > 1 ? String(v.length) : show(v[0]);
        if (v && typeof v === "object") return v.name || v.text || v.label || "";
        return typeof v === "number" || typeof v === "string" ? String(v) : "";
      };
      var defs = [
        ["sellStatus", app.$t("status")],
        ["tag", app.$t("tag")],
      ];
      return defs
        .filter(function (d) {
          return has(app[d[0]]);
        })
        .map(function (d) {
          return { key: d[0], label: d[1], value: show(app[d[0]]) };
        });
    },

    showSelect() {
      if (!this.isMobile) {
        return true;
      } else {
        return false;
      }
    },
    isMobile() {
      return this.$vuetify.breakpoint.name === "xs";
    },
    showHeaders() {
      var app = this;
      return this.headers.filter(function (s) {
        if (app.accountProp) {
          if (s.value === "fin4.name" || s.value === "given.name") {
          } else {
            return app.selectedHeaders.includes(s);
          }
        } else {
          return app.selectedHeaders.includes(s);
        }
      });
    },
    totals: function () {
      const totals = this.items.reduce(
        (acc, d, index) => {
          acc.debtor += d.sumDebtor ? parseFloat(d.sumDebtor) : 0;
          acc.creditor += d.sumCreditor ? parseFloat(d.sumCreditor) : 0;
          acc.debtorRemain +=
            +d.sumDebtor - +d.sumCreditor > 0 ? +d.sumDebtor - +d.sumCreditor : 0;
          acc.creditorRemain +=
            +d.sumCreditor - +d.sumDebtor > 0 ? +d.sumCreditor - +d.sumDebtor : 0;
          return acc;
        },
        {
          debtor: 0,
          creditor: 0,
          debtorRemain: 0,
          creditorRemain: 0,
        }
      );
      return totals;
    },
  },
  watch: {
    closing_doc_status: {
      handler(val) {
        if (this.documentTypeItems && this.documentTypeItems.length > 0) {
          this.DocumentTypeCheckboxs();
        }
      },
      deep: true,
    },
    opening_doc_status: {
      handler(val) {
        if (this.documentTypeItems && this.documentTypeItems.length > 0) {
          this.DocumentTypeCheckboxs();
        }
      },
      deep: true,
    },
    temperory_doc_status: {
      handler(val) {
        if (this.documentTypeItems && this.documentTypeItems.length > 0) {
          this.DocumentTypeCheckboxs();
        }
      },
      deep: true,
    },
    documentType(val) {
      if (val == "closingDocument") {
        this.closing_doc_status = false;
      }
      if (val == "initial") {
        this.opening_doc_status = false;
      }
      if (val == "closingTemporaryAccountsDocument") {
        this.temperory_doc_status = false;
      }
    },
    level: {
      handler(val, oldVal) {
        if (val === "back") {
          this.backLevel(oldVal);
        } else {
          this.checkLevelFilter(val);
        }
      },
      deep: true,
      immediate: true,
    },
    refId(val, oldVal) {
      // this.items = []
      this.getItems();
    },
    model() {
      this.$emit("input", this.model);
    },
    selected() {
      this.$emit("input", this.selected.text);
      if (this.selected.length > 0) {
        this.model = this.selected[0].text;
        this.temp = this.selected[0].text;
      }
      this.dialog = false;
    },
    search() {
      var app = this;
      app.loading = true;
      app.page = 1;
      clearTimeout(this.timer);
      this.timer = setTimeout(function () {
        app.getItems();
      }, 1000);
    },
    options: {
      handler() {
        var app = this;
        app.sortBy = [];
        app.options.sortBy.map(function (value, key) {
          const index = app.headers.findIndex((h) => h.value === value);
          app.sortBy.push(app.headers[index].table);
        });
        this.getItems();
      },
      deep: true,
    },
    sortBy() {
      const index = this.headers.findIndex((h) => h.value === this.sortBy);
      if (index > -1) {
        this.sortBy = this.headers[index].table;
      }
    },
  },
  activated() {
    // this.getItems()
  },
  beforeMount() {
    if (this.$route.name === "review") {
      this.type = "review";
    }
    if (this.$route.name === "profit&cost") {
      this.type = "profit&cost";
    }
    this.headers = [
      {
        text: this.$t("#"),
        align: "center",
        sortable: false,
        value: "actions",
        width: 42,
        class: "pl-action-col",
        cellClass: "pl-action-col",
      },
      {
        text: this.$t("code"),
        sortable: false,
        value: "code",
      },
      {
        text: this.$t("content"),
        sortable: false,
        value: "reviewContent",
      },
      {
        text: this.$t("debtorTurnover"),
        sortable: true,
        value: "sumDebtor",
        table: "sumDebtor",
      },
      {
        text: this.$t("creditorTurnover"),
        sortable: true,
        value: "sumCreditor",
        table: "sumCreditor",
      },
      {
        text: this.$t("debtorRemain"),
        sortable: true,
        value: "debtorRemain",
        table: "debtorRemain",
      },
      {
        text: this.$t("creditorRemain"),
        sortable: true,
        value: "creditorRemain",
        table: "creditorRemain",
      },
    ];
    this.headersMap = this.headers;
    this.selectedHeaders = this.headers;
    if (this.fin4Prop) {
      // const selectedHeaders = app.headers.findIndex(h => h.value === value)
    }
    this.productStatusItems = [
      {
        value: "active",
        text: this.$t("active"),
      },
      {
        value: "deactive",
        text: this.$t("deactive"),
      },
    ];
    if (this.input) {
      this.model = this.input;
    }
    this.remainItems = [
      {
        value: "debtorCreditor",
        text: this.$t("debtor") + " " + this.$t("creditor"),
      },
      {
        value: "debtor",
        text: this.$t("debtor"),
      },
      {
        value: "creditor",
        text: this.$t("creditor"),
      },
      {
        value: "zero",
        text: this.$t("zero"),
      },
    ];
    this.filterTypeItems = [
      {
        value: "month",
        text: this.$t("month"),
      },
      {
        value: "date",
        text: this.$t("date"),
      },
    ];
  },
  mounted() {
    this.fromFinancialYear = this.$store.state.financialYear;
    this.toFinancialYear = this.$store.state.financialYear;
    // this.getItems()
    this.$nextTick(() => {
      this.isReady = true;
    });
    this.fetchDocList();
  },
  methods: {
    resetFilters() {
      this.sellStatus = null;
      this.tag = null;
    },

    DocumentTypeCheckboxs() {
      if (!this.documentTypeItems?.length) return;
      const arrayCheckboxID = [];
      if (this.closing_doc_status) arrayCheckboxID.push("closingDocument");
      if (this.opening_doc_status) arrayCheckboxID.push("initial");
      if (this.temperory_doc_status)
        arrayCheckboxID.push("closingTemporaryAccountsDocument");
      if (arrayCheckboxID.length === 0) {
        this.documentType = [];
      } else {
        this.documentType = this.documentTypeItems.filter(
          (item) => !arrayCheckboxID.includes(item.id)
        );
      }
    },
    handleInput() {
      if (!this.isReady) return;
      this.getItems();
    },
    fetchDocList() {
      var app = this;
      app.$axios
        .get(this.$endpoint + "getdetail", {
          params: {
            select: "documentType",
            page: 1,
            currency: 2746,
          },
        })
        .then((r) => {
          app.documentTypeItems = r.data.data;
        })
        .catch((err) => {
          this.serverErrorHandeler(err);
        })
        .finally(() => (app.loading = false));
    },
    setLevel(item) {
      this.getTurnover = false;
      switch (this.level) {
        case "group":
          this.level = "total";
          this.group = [{ id: item.groupId, name: item.groupName }];
          break;
        case "total":
          this.level = "given";
          this.total = [{ id: item.totalId, name: item.totalName }];
          break;
        case "given":
          this.level = "detail";
          this.given = [{ id: item.givenId, name: item.givenName }];
          break;
        case "detail":
          if (!item.fin5_id) {
            this.getTurnover = true;
          } else {
            this.level = "fin5";
            if (item.fin4) {
              this.fin4 = [{ id: item.fin4_id, name: item.fin4 ? item.fin4.name : "" }];
            }
          }
          break;
        case "fin5":
          if (!item.fin6_id) {
            this.getTurnover = true;
          } else {
            this.level = "fin6";
            if (item.fin5) {
              this.fin5 = [{ id: item.fin5_id, name: item.fin5 ? item.fin5.name : "" }];
            }
          }
          break;
        case "fin6":
          this.getTurnover = true;
          break;
        default:
          this.level = "fin6";
          this.getTurnover = false;
      }
      if (this.getTurnover) {
        this.turnover(item);
      }
      // this.getItems()
    },
    backLevel(level) {
      this.getTurnover = false;
      if (level === "group") {
        this.level = "group";
      }
      if (level === "total") {
        this.group = null;
        this.level = "group";
      }
      if (level === "given") {
        this.total = null;
        this.level = "total";
      }
      if (level === "detail") {
        this.given = null;
        this.level = "given";
      }
      if (level === "fin5") {
        this.fin4 = null;
        this.level = "detail";
      }
      if (level === "fin6") {
        this.fin5 = null;
        this.level = "fin5";
      }
      if (level === "turnover") {
        this.level = "fin6";
        this.fin6 = null;
      }
    },
    openDeleteDialog(item) {
      this.deleteItem = item;
      this.deletDialog = true;
    },
    openTaskDialog(item) {
      this.refId = item.rel_id;
      this.taskId = item.id;
      this.taskDialog = true;
    },
    isEnabled(slot) {
      return this.enabled === slot;
    },
    edit(item) {
      this.$router.push({ name: "accountingEdit", params: { id: item.head_id } });
    },
    checkLevelFilter(level) {
      if (
        level == "group" &&
        (this.group != null || this.total != null || this.given != null)
      ) {
        this.group = null;
        this.total = null;
        this.given = null;
      }
      if (level == "total" && (this.total != null || this.given != null)) {
        this.total = null;
        this.given = null;
      }
      if (level == "given" && this.given != null) {
        this.given = null;
      }
      // if (level == 'detail' && this.fin4 != null) {
      //   this.fin4 = null
      // }
      // if (level == 'fin5' && this.fin5 != null) {
      //   this.fin5 = null
      // }
      // if (level == 'fin6' && this.fin6 != null) {
      //   this.fin6 = null
      // }
      this.getItems();
    },
    getItems() {
      var app = this;
      app.loading = true;
      app.$axios
        .get(this.$endpoint + "accountingreport", {
          params: {
            remain: app.remain,
            documentType: app.documentType,
            fromFinancialYear: app.fromFinancialYear ? app.fromFinancialYear.id : null,
            toFinancialYear: app.toFinancialYear ? app.toFinancialYear.id : null,
            fromMonth: app.fromMonth,
            toMonth: app.toMonth,
            fromNumber: app.fromNum,
            toNumber: app.toNum,
            detail: app.fin4,
            fin5: app.fin5,
            fin6: app.fin6,
            given: app.given,
            account: app.accountProp,
            group: app.group,
            branch: app.branch,
            total: app.total,
            search: app.search,
            page: app.allRows ? app.excelPage : app.options.page,
            fromDate: app.fromDate,
            toDate: app.toDate,
            refId: app.refId,
            level: app.level,
            type: app.type,
            report: "review",
            sortBy: app.sortBy,
            groupType: app.type === "profit&cost" ? "costBenefit" : null,
            options: app.options,
            tag: app.tag,
            typeForm: app.typeForm,
          },
        })
        .then((res) => {
          res = res.data;
          if (!app.allRows) {
            app.items = res.data;
            app.totalItems = res.total;
            app.pageCount = res.last_page;
            app.from = res.from;
            app.creatExcelData(res.data);
          } else {
            app.generateExcellForAllData(res.data, res.last_page);
          }
        })
        .catch((err) => {
          this.serverErrorHandeler(err);
        })
        .finally(() => (app.loading = false));
    },
    remove() {
      var app = this;
      if (!app.deleteItem) return false;
      app.loading = true;
      app.$axios
        .delete(this.$endpoint + "invoice/" + this.deleteItem.id)
        .then((res) => {
          res = res.data;
          app.deletDialog = false;
          app.deleteItem = null;
          app.getItems();
        })
        .catch((err) => {
          this.deletDialog = false;
          this.serverErrorHandeler(err);
        })
        .finally(() => (app.loading = false));
    },
    visitTurnOver(item) {
      const payload = {
        groupProp:
          item.groupId && item.groupName
            ? { id: item.groupId, name: item.groupName }
            : null,
        totalProp:
          item.totalId && item.totalName && this.level != "group"
            ? { id: item.totalId, name: item.totalName }
            : null,
        givenProp:
          item.givenId && item.givenName && this.level != "group" && this.level != "total"
            ? { id: item.givenId, name: item.givenName }
            : null,
        detailProp:
          item.fin4_id && item.fin4?.name
            ? { id: item.fin4_id, name: item.fin4?.name }
            : null,
        fin5Prop:
          item.fin5_id &&
          item.fin5?.name &&
          this.level != "group" &&
          this.level != "total" &&
          this.level != "given" &&
          this.level != "detail"
            ? { id: item.fin5_id, name: item.fin5?.name }
            : null,
        fin6Prop:
          item.fin6_id &&
          item.fin6?.name &&
          this.level != "group" &&
          this.level != "total" &&
          this.level != "given" &&
          this.level != "detail" &&
          this.level != "fin5"
            ? { id: item.fin6_id, name: item.fin6?.name }
            : null,
        fromMonth: this.fromMonth != null ? this.fromMonth + "/01" : null,
        toMonth: this.toMonth != null ? this.resolveToMonth(this.toMonth) : null,
        fromDateProp: this.fromDate != null ? this.fromDate : null,
        toDateProp: this.toDate != null ? this.toDate : null,
        branchProp: this.branch != null ? this.branch : null,
        fromNumberProp: this.fromNum != null ? this.fromNum : null,
        toNumberProp: this.toNum != null ? this.toNum : null,
        tagProp: this.tag != null ? this.tag : null,
      };

      this.$router.push({
        name: "turnoverDetail",
        params: {
          id: this.resolveIdParams(item),
          type: this.resolveLevelParams(),
          tabName: this.resolveTabName(item),
          tabNameNew: true,
        },
        query: {
          filters: JSON.stringify(payload),
        },
      });
    },
    resolveToMonth(month) {
      if (!month) return null;
      const [year, m] = month.split("/").map(Number);
      let days;
      if (m >= 1 && m <= 6) {
        days = 31;
      } else if (m >= 7 && m <= 11) {
        days = 30;
      } else if (m === 12) {
        days = 29;
      } else {
        return null;
      }
      return `${year}/${String(m).padStart(2, "0")}/${days}`;
    },
    resolveTabName(item) {
      if (this.level == "group") {
        return (
          this.$t("turn") + " " + this.$t("group") + " " + "(" + item.groupName + ")"
        );
      }
      if (this.level == "total") {
        return (
          this.$t("turn") + " " + this.$t("total") + " " + "(" + item.totalName + ")"
        );
      }
      if (this.level == "given") {
        return (
          this.$t("turn") + " " + this.$t("given") + " " + "(" + item.givenName + ")"
        );
      }
      if (this.level == "detail") {
        return (
          this.$t("turn") + " " + this.$t("detail") + " " + "(" + item.fin4?.name + ")"
        );
      }
      if (this.level == "fin5") {
        return (
          this.$t("turn") + " " + this.$t("fin5") + " " + "(" + item.fin5?.name + ")"
        );
      }
      if (this.level == "fin6") {
        return (
          this.$t("turn") + " " + this.$t("fin6") + " " + "(" + item.fin6?.name + ")"
        );
      }
    },
    resolveLevelParams() {
      if (this.level == "group") {
        return "group";
      }
      if (this.level == "total") {
        return "total";
      }
      if (this.level == "given") {
        return "given";
      }
      if (this.level == "detail") {
        return "detail";
      }
      if (this.level == "fin5") {
        return "fin5";
      }
      if (this.level == "fin6") {
        return "fin6";
      }
    },
    resolveIdParams(item) {
      if (this.level == "group") {
        return item.groupId;
      }
      if (this.level == "total") {
        return item.totalId;
      }
      if (this.level == "given") {
        return item.givenId;
      }
      if (this.level == "detail") {
        return item.fin4_id;
      }
      if (this.level == "fin5") {
        return item.fin5_id;
      }
      if (this.level == "fin6") {
        return item.fin6_id;
      }
    },
    turnover(item) {
      if (!item.fin4 && this.getTurnover) {
        this.$router.push({
          name: "turnoverDetail",
          params: {
            givenProp: { id: item.givenId, name: item.givenName },
            tabName: item.givenName,
          },
        });
      } else {
        if (this.level === "detail") {
          this.$router.push({
            name: "turnoverDetail",
            params: {
              id: item.fin4_id,
              givenProp: { id: item.givenId, name: item.givenName },
              accountProp: { id: item.fin4_id, name: item.fin4.name },
              tabName: item.fin4.name,
            },
          });
        }
        if (this.level === "fin5") {
          this.$router.push({
            name: "turnoverDetail",
            params: {
              id: item.fin4_id,
              givenProp: { id: item.givenId, name: item.givenName },
              fin5Prop: { id: item.fin5_id, name: item.fin5.name },
              tabName: item.fin5.name,
            },
          });
        }
        if (this.level === "fin6") {
          this.$router.push({
            name: "turnoverDetail",
            params: {
              id: item.fin4_id,
              givenProp: { id: item.givenId, name: item.givenName },
              fin6Prop: { id: item.fin6_id, name: item.fin6.name },
              fin5Prop: { id: item.fin5_id, name: item.fin5.name },
              tabName: item.fin6.name,
            },
          });
        }
      }
    },
    givenTurnover(item) {},
    removegroup() {
      var app = this;
      app.loading = true;
      app.$axios
        .get(this.$endpoint + "invoice", {
          params: {
            deleteItems: app.selected,
          },
        })
        .then((res) => {
          res = res.data;
          app.deletDialog = false;
          app.deleteItem = null;
          app.selected = [];
          app.getItems();
        })
        .catch((err) => {
          this.deletDialog = false;
          this.serverErrorHandeler(err);
        })
        .finally(() => (app.loading = false));
    },
    creatExcelData(data, type = "page") {
      var app = this;
      if (type === "page") {
        app.excelItems = [];
      }
      data.map(function (d, index) {
        app.excelItems.push({
          row: index + 1,
          content:
            d.groupName +
            " " +
            (app.level !== "group" ? " / " + d.totalName : "") +
            " " +
            (app.level !== "group" && app.level !== "total" ? " / " + d.givenName : "") +
            " " +
            (app.level !== "group" &&
            app.level !== "total" &&
            app.level !== "given" &&
            app.level === "detail" &&
            d.fin4
              ? " / " + d.fin4.name
              : ""),
          fin4_name: d.fin4 ? d.fin4.name : null,
          fin4_id: d.fin4 ? d.fin4.id : null,
          debtor: d.sumDebtor,
          creditor: d.sumCreditor,
          remainDebtor:
            +d.sumDebtor - +d.sumCreditor > 0 ? +d.sumDebtor - +d.sumCreditor : 0,
          remainCreditor:
            +d.sumCreditor - +d.sumDebtor > 0 ? +d.sumCreditor - +d.sumDebtor : 0,
        });
      });
    },
  },
};
</script>

<style scoped lang="scss">
@import "~@/sass/design-system/list/pro-list";

.v-chip {
  padding: 15px;
}
.small-tooltip {
  padding: 7px !important;
  font-size: 11px;
  line-height: 1.2;
}
</style>

<style lang="sass">
@import '~vuetify/src/styles/tools/_rtl.sass'
.border-datatable
 .theme--light.v-data-table
   .v-data-table__wrapper
     table
       thead
         tr:last-child
           th
             border-top : 1px solid #e3e3e3 !important
             border-left : 1px solid #e3e3e3 !important
             padding : 0px 8px !important
             background-color: #f5f5f5

 .theme--light.v-data-table
   .v-data-table__wrapper
     table
       thead
         tr:last-child
           th:first-child
             border-right : 1px solid #e3e3e3 !important

 .theme--light.v-data-table > .v-data-table__wrapper > table > tbody > tr:not(:last-child) > td:not(.v-data-table__mobile-row), .theme--light.v-data-table > .v-data-table__wrapper > table > tbody > tr:not(:last-child) > th:not(.v-data-table__mobile-row)
   border-left : 1px solid #e3e3e3 !important
   padding : 0px 8px !important
 .theme--light.v-data-table > .v-data-table__wrapper > table > tbody > tr:not(:last-child) > td:not(.v-data-table__mobile-row):first-child, .theme--light.v-data-table > .v-data-table__wrapper > table > tbody > tr:not(:last-child) > th:not(.v-data-table__mobile-row)
   border-right : 1px solid #e3e3e3 !important
   padding : 0px 8px !important
 .theme--light.v-data-table > .v-data-table__wrapper > table > tbody > tr:last-child > td:first-child:not(.v-data-table__mobile-row)
   border-right : 1px solid #e3e3e3 !important
 .theme--light.v-data-table > .v-data-table__wrapper > table > tbody > tr:last-child > td:last-child:not(.v-data-table__mobile-row)
   border-left : 1px solid #e3e3e3 !important

.v-text-field--outlined.v-input--dense.v-text-field--outlined > .v-input__control > .v-input__slot
  min-height: 32px !important
</style>
